export function enumValueFromString<E extends { [k: string]: string | number }>(
	enumObj: E,
	input: string,
	opts?: { searchValue?: boolean }
): E[keyof E] | undefined {
	const { searchValue = false } = opts ?? {};

	if (searchValue) {
		for (const val of Object.values(enumObj) as E[keyof E][]) {
			if (val.toString() === input) {
				return val;
			}
		}
		return undefined;
	}

	if (Object.prototype.hasOwnProperty.call(enumObj, input)) {
		return enumObj[input as keyof E];
	}

	return undefined;
}
